// Pure helpers for the financial-period lock (no Firestore) — see periodLockService.js.

// "2026-09", "2026-09-30" -> "2026-09"; anything else -> "".
export function normalizePeriod(value) {
  const match = String(value || "").trim().match(/^(\d{4})-(0[1-9]|1[0-2])(?:-\d{2})?$/);
  return match ? `${match[1]}-${match[2]}` : "";
}

export function lockedMessage(period) {
  return `${period} is closed, so it can no longer be changed. Ask an admin to reopen it from Monthly P&L, or post this as an adjustment in the next open month.`;
}
